<div class="import-file-preview">
    <!-- Loading mask overlay -->
    <div class="loading-mask" *ngIf="isLoading">
        <div class="loading-content">
            <mat-spinner diameter="50"></mat-spinner>
            <p>{{ 'LoadingData' | translate: {Default: "Loading data..."} }}</p>
        </div>
    </div>

    <div class="import-file-preview-header">
        <h6 appLocalizationPopupDirective localizationCode="ImportFilePreview">
            {{ 'ImportFilePreview' | translate: {Default: "Import File Preview"} }}
        </h6>

        <button 
            *ngIf="importId"
            mat-stroked-button 
            setColor="primaryColour" 
            color="primary" 
            appLocalizationPopupDirective localizationCode="DownloadFile" 
            [disabled]="isLoading"
            appPreventDoubleClick (throttledClick)="downloadImportFile()"
        >
            <mat-icon class="material-icons-outlined">download</mat-icon>
            {{ 'DownloadFile' | translate: {Default: "Download File"} }}
        </button> 
    </div>
    <kendo-spreadsheet
        #spreadsheet
        [sheets]="[]"
        [menuItems]="items"
        style="height: 600px; width: 100%"
        >
    </kendo-spreadsheet>
</div>